import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import Button from '@zacousticrepo/grommet-v1-custom/components/Button';
import CheckBox from '@zacousticrepo/grommet-v1-custom/components/CheckBox';
import Table from '@zacousticrepo/grommet-v1-custom/components/Table';
import TableHeader from '@zacousticrepo/grommet-v1-custom/components/TableHeader';
import TextInput from '@zacousticrepo/grommet-v1-custom/components/TextInput';
import { fetchCustomerEmails, setCustomerEmails } from '../screens/hiddenEndpointsActions';
import store from '../store';

class HiddenAdminCustomerEmailControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
            customerEmails: [],
            modifiedRows: {},
            newRows: []
        };
        this.props.dispatch(fetchCustomerEmails());
        this._onCheckboxClick = this._onCheckboxClick.bind(this);
        this._onTextInputChange = this._onTextInputChange.bind(this);
        this._getNewModifiedRows = this._getNewModifiedRows.bind(this);
        this._onSave = this._onSave.bind(this);
        this._onRevert = this._onRevert.bind(this);
        this._onNewRow = this._onNewRow.bind(this);
        this.scrollToBottom = this.scrollToBottom.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (typeof newProps.dbCustomerEmails !== 'undefined') {
            let modifiedRows = {};
            newProps.dbCustomerEmails.map((email, index) => {
                modifiedRows[index] = false;
            });
            this.setState({ customerEmails: newProps.dbCustomerEmails, modifiedRows: modifiedRows, newRows: [] });
        }
    }

    deepCopy(thing) {
        return JSON.parse(JSON.stringify(thing));
    }

    scrollToBottom() {
        this.el.scrollIntoView({ behavior: 'instant' });
    }

    _onNewRow() {
        const state = store.getState();
        const newRowPosition = this.state.customerEmails.length;
        let newCustomerEmails = this.deepCopy(this.state.customerEmails);
        let newRows = this.deepCopy(this.state.newRows);
        newCustomerEmails.push({ EmailAddress: '', IsEnabled: false, ClientId: state.session.clientId });
        newRows.push(newRowPosition);
        this.setState({
            customerEmails: newCustomerEmails,
            newRows: newRows
        });
        this.scrollToBottom();
    }

    _onCheckboxClick({ target, option, value }) {
        const placeInArray = parseInt(target.id);
        let newCustomerEmails = this.deepCopy(this.state.customerEmails);
        newCustomerEmails[placeInArray].IsEnabled = !newCustomerEmails[placeInArray].IsEnabled;

        this.setState({
            customerEmails: newCustomerEmails,
            modifiedRows: this._getNewModifiedRows(newCustomerEmails, placeInArray)
        });
    }

    _onTextInputChange({ target, option, value }) {
        const placeInArray = parseInt(target.id);
        let newCustomerEmails = this.deepCopy(this.state.customerEmails);
        newCustomerEmails[placeInArray].EmailAddress = target.value;
        this.setState({
            customerEmails: newCustomerEmails,
            modifiedRows: this._getNewModifiedRows(newCustomerEmails, placeInArray)
        });
    }

    _getNewModifiedRows(newArray, placeInArray) {
        const modifiedRows = this.deepCopy(this.state.modifiedRows);
        if (typeof this.state.newRows.find(x => x === placeInArray) === 'undefined') {
            const emailAddressMatch =
                newArray[placeInArray].EmailAddress === this.props.dbCustomerEmails[placeInArray].EmailAddress;
            const isEnabledMatch =
                newArray[placeInArray].IsEnabled === this.props.dbCustomerEmails[placeInArray].IsEnabled;
            modifiedRows[placeInArray] = !(emailAddressMatch && isEnabledMatch);
        }
        return modifiedRows;
    }

    _onSave() {
        const newCustomerEmails = this.state.customerEmails.filter(email => email.EmailAddress.length >= 7);
        this.props.dispatch(setCustomerEmails(newCustomerEmails));
    }

    _onRevert() {
        this.componentWillReceiveProps({ dbCustomerEmails: this.props.dbCustomerEmails });
    }

    render() {
        let rows = [];
        if (typeof this.state.customerEmails !== 'undefined') {
            for (let i = 0; i < this.state.customerEmails.length; i++) {
                let trClassName = null;
                if (typeof this.state.newRows.find(x => x === i) !== 'undefined') {
                    trClassName = 'row-new';
                } else {
                    trClassName = this.state.modifiedRows[i] ? 'row-modified' : '';
                }

                rows.push(
                    <tr className={trClassName}>
                        <td>
                            <TextInput
                                id={i}
                                value={this.state.customerEmails[i].EmailAddress}
                                onDOMChange={this._onTextInputChange}
                                placeholder="Email Address"
                            />
                        </td>
                        <td>
                            <CheckBox
                                id={i}
                                checked={!this.state.customerEmails[i].IsEnabled}
                                onChange={this._onCheckboxClick}
                            />
                        </td>
                    </tr>
                );
            }
        }

        return (
            <div className="hiddenAdminCustomerEmailControl">
                <Table style={{ width: '40em' }}>
                    <TableHeader labels={['Email Address', 'Blacklisted']} />
                    <tbody>{rows}</tbody>
                </Table>
                <div style={{ height: '4em' }} />
                <div
                    ref={el => {
                        this.el = el;
                    }}
                />
                <div className="button-controls">
                    <Button onClick={this._onNewRow} label="+ New Email" />
                    <Button secondary={true} onClick={this._onRevert} label="Revert changes" />
                    <Button primary={true} onClick={this._onSave} label="Save" />
                </div>
            </div>
        );
    }
}

HiddenAdminCustomerEmailControl.propTypes = {
    dispatch: PropTypes.func.isRequired
};

const select = (state, ownProps) => ({ ...state.hiddenEndpoints });

export default connect(select)(HiddenAdminCustomerEmailControl);
